// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__7Igrd","primary":"Button_primary__96Iji","cancel":"Button_cancel__2San5","danger":"Button_danger__3DH89"};